import { SOLUTION_SECTORS, solutionHref } from "@/app/solutions/sectors";

import { ACCOUNTANTS, CONSULTANCIES } from "./sectors/content";

/** Sector titles are two display lines; a menu reads them as one. */
const sectorLine = (title: string) => title.replace(/\n/g, " ");

/**
 * Every sector page, in the order the nav's Solutions menu and the footer's
 * Solutions column list them: the two pages under /for/, then the solution
 * pages (sectors.ts). `line` is the page's headline, for the menu.
 */
export const SOLUTION_LINKS: readonly { label: string; href: string; line: string }[] = [
  { label: "Accountancy firms", href: "/for/accountants", line: sectorLine(ACCOUNTANTS.title) },
  { label: "Agencies & consultancies", href: "/for/consultancies", line: sectorLine(CONSULTANCIES.title) },
  ...SOLUTION_SECTORS.map((sector) => ({
    label: sector.name,
    href: solutionHref(sector),
    line: sector.hero.title.join(" "),
  })),
];
